import React, { Suspense, useEffect, useState } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls } from '@react-three/drei';
import * as THREE from 'three';
import { MTLLoader, OBJLoader } from 'three-stdlib';

function Model({ modelName }) {
  const [object, setObject] = useState();

  useEffect(() => {
    const path = `/models/${modelName}/`;

    const mtlLoader = new MTLLoader();
    mtlLoader.setPath(path);

    mtlLoader.load(
      'model.mtl',
      (materials) => {
        materials.preload();

        const objLoader = new OBJLoader();
        objLoader.setPath(path);
        objLoader.setMaterials(materials);

        objLoader.load('model.obj', (obj) => {
          let texturesUsed = false;

          obj.traverse((child) => {
            if (child.isMesh) {
                child.material.side = THREE.DoubleSide;
              const mat = child.material;

              // PrÃ¼fen, ob eine Textur geladen wurde
              if (mat.map && mat.map.image) {
                texturesUsed = true;
              }
            }
          });

          if (!texturesUsed) {
            // Texturen fehlen â verwende Vertexfarben
            obj.traverse((child) => {
              if (child.isMesh) {
                child.material = new THREE.MeshStandardMaterial({
                  vertexColors: true,
                  side: THREE.DoubleSide,
                });

                const geometry = child.geometry;
                if (!geometry.attributes.color) {
                  const count = geometry.attributes.position.count;
                  const colors = new Float32Array(count * 3);
                  for (let i = 0; i < count; i++) {
                    colors[i * 3 + 0] = Math.random();
                    colors[i * 3 + 1] = Math.random();
                    colors[i * 3 + 2] = Math.random();
                  }
                  geometry.setAttribute('color', new THREE.BufferAttribute(colors, 3));
                }
              }
            });
          }

          setObject(obj);
        });
      },
      undefined,
      () => {
        // MTL konnte nicht geladen werden â auf Vertexfarben zurÃ¼ckgreifen
        const objLoader = new OBJLoader();
        objLoader.setPath(path);
        objLoader.load('model.obj', (obj) => {
          obj.traverse((child) => {
            if (child.isMesh) {
              child.material = new THREE.MeshStandardMaterial({
                vertexColors: true,
                side: THREE.DoubleSide,
              });

              const geometry = child.geometry;
              if (!geometry.attributes.color) {
                const count = geometry.attributes.position.count;
                const colors = new Float32Array(count * 3);
                for (let i = 0; i < count; i++) {
                  colors[i * 3 + 0] = Math.random();
                  colors[i * 3 + 1] = Math.random();
                  colors[i * 3 + 2] = Math.random();
                }
                geometry.setAttribute('color', new THREE.BufferAttribute(colors, 3));
              }
            }
          });
          setObject(obj);
        });
      }
    );
  }, [modelName]);

  return object ? <primitive object={object} /> : null;
}

export default function Viewer({ modelName }) {
  return (
    <div style={{ height: '100vh' }}>
      <Canvas style={{ background: '#aaa' }} camera={{ position: [0, 20, 20] }}>
      <gridHelper args={[100, 100]} />
        <ambientLight intensity={0.4} />
        <directionalLight position={[5, 5, 5]} />
        <Suspense fallback={null}>
          <Model modelName={modelName} />
        </Suspense>
        <OrbitControls />
      </Canvas>
    </div>
  );
}